import { CommonModule } from '@angular/common';
import {
    Component,
    EventEmitter,
    Input,
    InputSignal,
    Output,
    effect,
    inject,
    input,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { DatiqIconsModule } from '@dat/datiq-components-pkg/icons';
import { DatiqTemplateModule } from '@dat/datiq-components-pkg/template';

import { IqEventBusBrokerService } from '@dat/iq-event-bus';

@Component({
    selector: 'iq-controls-submit-button',
    standalone: true,
    imports: [CommonModule, DatiqTemplateModule, MatIcon, DatiqIconsModule],
    templateUrl: './iq-controls-submit-button.component.html',
    styleUrl: './iq-controls-submit-button.component.scss',
})
export class IqControlsSubmitButtonComponent {
    id: InputSignal<string> = input('');
    label: InputSignal<string> = input('Reset');
    disabled: InputSignal<boolean> = input(false);
    isPageControl: InputSignal<boolean> = input(false);

    @Input()
    fg: FormGroup;

    @Output()
    submitted = new EventEmitter<void>();

    private _bus: IqEventBusBrokerService = inject(IqEventBusBrokerService);

    constructor(private readonly _fb: FormBuilder) {}

    submit() {
        if (!this.fg.valid) return;

        /**
         * This dispatches an event indicating the form is submitted.
         *
         *
         * To listen to these events, you can use the following format in your Dashboard, Section, or Component:
         *
         * ```json
         * {
         *  "onSubmit": [
         *    {
         *      "name": "EVENT_NAME",
         *      "payload": {},
         *      "sourceEventRule": {
         *          "payload": [
         *            {
         *                "path": "control.id",
         *                "operator": "eq",
         *                "value": "CONTROL_ID"
         *            },
         *          ]
         *      },
         *      "rules": []
         *    },
         *   ]
         * }
         * ```
         */
        const dispatch = () =>
            this._bus.dispatch({
                name: 'type:submit',
                payload: {
                    id: this.id(),
                    ...this.createEmitData(),
                },
            });

        dispatch();

        this.submitted.emit();
    }

    private createEmitData() {
        const emitData = {
            form: {
                ...this.fg.value,
                valid: this.fg.valid,
                errors: this.fg.errors,
            },
        };
        return emitData;
    }
}
